/**
 * Regla única de avance — v1 (documentada en docs/PROYECTOS_COMENTARIOS.md)
 *
 *   Proyecto: tareas en estado "Completado" × 100 / total de tareas.
 *   Tarea:    subtareas completadas × 100 / total de subtareas.
 *   Sin elementos → 0 %. Redondeo al entero más cercano (0,5 hacia arriba).
 *   Las subtareas NO influyen en el porcentaje del proyecto.
 *
 * Es réplica exacta de public.calcular_progreso() en la base de datos, que es
 * la fuente de verdad para progreso_proyectos, el portal y la vista pública.
 * Usar esta función solo cuando el dato se calcula en el navegador (por
 * ejemplo, tras mover una tarea en el Kanban, antes de recargar).
 */
export const ESTADO_COMPLETADO = "Completado";

export function calcularProgreso(completadas, total) {
  const t = Number(total) || 0;
  if (t <= 0) return 0;
  return Math.round(((Number(completadas) || 0) * 100) / t);
}

export function progresoTareas(tareas = []) {
  const total = tareas.length;
  const completadas = tareas.filter(t => t.estado === ESTADO_COMPLETADO).length;
  return { total, completadas, pendientes: total - completadas, pct: calcularProgreso(completadas, total) };
}

export function progresoSubtareas(subtareas = []) {
  const total = subtareas.length;
  const completadas = subtareas.filter(s => s.completada).length;
  return { total, completadas, pct: calcularProgreso(completadas, total) };
}
